import script from "./ShareProjectDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShareProjectDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ShareProjectDialog.vue?vue&type=style&index=0&id=b291e22a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b291e22a"]])

export default __exports__